<template>
  <InputField
    :label="label"
    :show="show"
    :tooltip="tooltip">
    <div v-if="subtext" class="option-toggle-subtext">{{ subtext }}</div>
    <span class="option-toggle-wrapper">
      <span
        v-for="option in Object.keys(options)"
        v-bind:key="option"
        class="option-toggle-item"
        @click="handleClick(options[option])"
        v-bind:class="[options[option] === value ? 'selected-item' : '']">
          {{option}}</span>
    </span>
   <div v-if="footertext" class="option-toggle-footertext">{{ footertext }}</div>
  </InputField>
</template>
<script>
import InputField from './form-elements/InputField';

export default {
  props: {
    handleChange: Function,
    label: String,
    parent: Object,
    model: String,
    tooltip: String,
    subtext: String,
    footertext: String,
    show: {
      type: Boolean,
      default: true,
    },
    // options object where key is displayed on ui
    // and the value is passed on option click
    options: Object,
  },
  components: { InputField },
  computed: {
    value() {
      if (this.parent[this.model] === undefined) return false;

      return this.parent[this.model];
    },
  },
  methods: {
    handleClick(value) {
      if (value !== this.value && this.handleChange) {
        return this.handleChange({ srcElement: { value } }, this.model);
      }

      this.$set(this.parent, this.model, value);
    },
  },
};
</script>
<style>
  .option-toggle-wrapper {
    font-size: 12px;
    text-transform: uppercase;
    box-shadow: 0 6px 6px rgba(0, 0, 0, 0.2);
  }

  .option-toggle-item {
    background: #e8f0f7;
    padding: 5px 8px;
    cursor: pointer;
    border: 1px solid #bfbfbf;
    color: #bfbfbf;
    transition: 0.2s ease;
  }

  .option-toggle-subtext {
    margin: 5px 0px 15px 0px;
  }

  .option-toggle-footertext {
    margin-top: 10px;
  }

  .option-toggle-item:first-child {
    border-radius: 5px 0px 0px 5px;
    border-right: none;
  }

  .option-toggle-item:last-child {
    border-radius: 0px 5px 5px 0px;
    border-left: none;
  }

  .option-toggle-item.selected-item {
    background: #2d95e4;
    color: white;
  }
</style>
